import { render } from "./MiezzButton.vue?vue&type=template&id=f4d829f4&scoped=true&ts=true"
import script from "./MiezzButton.vue?vue&type=script&lang=ts"
export * from "./MiezzButton.vue?vue&type=script&lang=ts"

import "./MiezzButton.vue?vue&type=style&index=0&id=f4d829f4&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4d829f4"]])

export default __exports__